// Zdroj pravdy pre texty landingu — edituje sa ručne. Generátor k tomuto neexistuje.
const sk = {
  "nav": {
    "download": "Stiahnuť",
    "features": "Funkcie",
    "howItWorks": "Ako to funguje",
    "forEmployees": "Pre zamestnancov",
    "pricing": "Cenník",
    "login": "Prihlásenie",
    "tryFree": "Vyskúšať zadarmo",
    "tryFree3": "Vyskúšať 3 mesiace zadarmo",
    "openMenu": "Otvoriť menu",
    "closeMenu": "Zavrieť menu"
  },
  "employer": {
    "title": "Čo získate ako firma",
    "leadBefore": "Pridáte ľudí, vidíte dochádzku a riešite žiadosti v",
    "leadLink": "appke",
    "leadAfter": "— z počítača, bez inštalácie.",
    "features": [
      {
        "title": "Kto je v práci — a kto nie",
        "description": "Vidíte, kto pracuje, kto je na prestávke alebo má voľno. Bez volania po celom tíme."
      },
      {
        "title": "Firemný chat a hovory",
        "description": "Skupiny podľa prevádzok, hovory aj video priamo v appke. Pracovné veci ostanú vo firme, nie v súkromnom WhatsAppe."
      },
      {
        "title": "Dochádzka a história",
        "description": "Príchody, odchody a prestávky. Úpravy záznamov a export pre účtovníctvo."
      },
      {
        "title": "Pracoviská a QR kódy",
        "description": "QR na vstup alebo recepciu. Scan v appke na Androide aj iPhone."
      },
      {
        "title": "Žiadosti od zamestnancov",
        "description": "Oprava času alebo zabudnutý odchod — schválite alebo zamietnete jedným klikom."
      },
      {
        "title": "AI asistent nad dochádzkou",
        "description": "Spýtate sa „Kto je dnes v práci?“ alebo „Koľko hodín mal Peter v júni?“ — odpoveď príde z vašich dát."
      }
    ]
  },
  "employerPeople": {
    "title": "Čo máte v appke",
    "lead": "Prehľad o ľuďoch a dochádzke v prehliadači na my.effzone.com — nie chat oddelený od toho, kto je dnes v práci.",
    "block1Title": "Kto je v práci — a kto nie",
    "block1Desc": "Vidíte, kto práve pracuje, kto je na prestávke alebo má voľno. Bez volania po celom tíme.",
    "block1Alt": "Effzone — prehľad kto je v práci v appke",
    "block2Title": "Zamestnanci na pár klikov",
    "block2Desc": "Pridáte meno a telefónne číslo. Človek dostane SMS kód, prihlási sa a je v systéme."
  },
  "employerComms": {
    "title": "Žiadosti a správy",
    "lead": "Schvaľovanie úprav dochádzky a oznámenia priamo do appky zamestnancov.",
    "block1Title": "Žiadosti od zamestnancov",
    "block1Desc": "Zabudnutý odchod alebo oprava času — pošlú žiadosť v appke, vy ju schválite alebo zamietnete.",
    "block2Title": "Správy priamo do appky",
    "block2Desc": "Oznámenie alebo notifikácia pre celú firmu alebo len pre vybraných — bez mailov, ktoré nikto nečíta.",
    "block2Alt": "Effzone — firemný chat a správy"
  },
  "employerAttendance": {
    "title": "Dochádzka a pracoviská",
    "lead": "História zmien, exporty a QR check-in — bez terminálu alebo špeciálnej čítačky.",
    "block1Title": "Dochádzka a história",
    "block1Desc": "Príchody, odchody a prestávky pre každého deň. Úpravy záznamov a export, keď to treba na účtovníctvo.",
    "block2Title": "Pracoviská a QR kódy",
    "block2Desc": "Vytvoríte pracovisko, vytlačíte QR a dáte ho na vstup alebo recepciu. Zamestnanec naskenuje v appke na Androide aj iPhone. Voliteľne aj obmedzenie podľa polohy."
  },
  "faq": {
    "title": "Časté otázky",
    "items": [
      {
        "q": "Čo sa stane po troch mesiacoch zadarmo?",
        "a": "Nič automatické — pri registrácii od vás nepýtame platobnú kartu. Ozveme sa a dohodneme sa, či pokračujete."
      },
      {
        "q": "Sleduje appka polohu ľudí?",
        "a": "Nie. Poloha sa overí len v momente označenia príchodu na pracovisku (ak si firma zapne overovanie polohy) — počas dňa appka polohu nesleduje."
      },
      {
        "q": "Čo ak niekto nemá smartfón?",
        "a": "Dochádzku si označí cez webový prehliadač na my.effzone.com, alebo mu záznam doplní admin v appke."
      },
      {
        "q": "Ako dostanem podklady pre mzdy?",
        "a": "Dochádzku stiahnete do Excelu na pár klikov a pošlete účtovníčke ako doteraz."
      },
      {
        "q": "Vieme to kedykoľvek zrušiť?",
        "a": "Áno — bez viazanosti a bez poplatku. Dochádzku si pred zrušením stiahnete do Excelu."
      }
    ]
  },
  "cta": {
    "title": "Chcete to vyskúšať vo svojej firme?",
    "textBefore": "Založte si účet v",
    "textLink": "appke",
    "textAfter": " alebo nám napíšte — pomôžeme vám nastaviť pracovisko a pridať prvých zamestnancov.",
    "tryFree": "Vyskúšať 3 mesiace zadarmo",
    "contact": "Napíšte nám"
  },
  "footer": {
    "downloadApp": "Stiahnuť aplikáciu",
    "privacy": "Ochrana súkromia",
    "terms": "Podmienky",
    "admin": "Webová appka"
  },
  "storeBadges": {
    "appStore": "Stiahnuť v App Store",
    "googlePlay": "Stiahnuť na Google Play"
  },
  "hero": {
    "ctaDownload": "Stiahnuť aplikáciu",
    "headlineLine1": [
      "Dochádzka"
    ],
    "headlineLine2": [
      "a firemná",
      "komunikácia"
    ],
    "headlineAccent": [
      "v",
      "jednej",
      "appke."
    ],
    "lead": "Zamestnanec si označí príchod cez QR kód pri vstupe. Vy vidíte, kto je v práci a kto má voľno. Novinky, ankety aj chat máte v jednej appke — nie po WhatsAppe a mailoch, kde sa po pár dňoch všetko stratí.",
    "ctaPrimary": "Vyskúšať 3 mesiace zadarmo",
    "pricenote": "Prvé 3 mesiace zadarmo · potom 1,90 € za aktívneho zamestnanca mesačne · bez viazanosti",
    "statsNote": "Čísla z databázy Effzone · júl 2026",
    "phoneAlt": "Effzone — prehľad kto je v práci, feed a firemná komunikácia",
    "card1Title": "Príchod 07:58",
    "card1Sub": "QR sken · Sklad Bratislava",
    "card2Title": "Nová správa",
    "card2Sub": "Ranná zmena · 3 reakcie",
    "card3Title": "Zmena ukončená",
    "card3Sub": "Automaticky o 16:00 · Predajňa Nitra"
  },
  "stats": {
    "shifts": "odpracovaných zmien",
    "hours": "odpracovaných hodín",
    "months": "mesiacov v prevádzke"
  },
  "marquee": {
    "qrAttendance": "QR dochádzka",
    "locationVerify": "Overenie polohy",
    "groupChat": "Skupinový chat",
    "callsVideo": "Hovory a video",
    "aiAssistant": "AI asistent",
    "autoShiftEnd": "Automatické ukončenie zmien",
    "payrollExport": "Export miezd",
    "changeRequests": "Žiadosti o zmeny",
    "polls": "Ankety",
    "companyNews": "Firemné novinky",
    "multipleWorkplaces": "Viac pracovísk",
    "statistics": "Štatistiky"
  },
  "howItWorks": {
    "title": "Ako to funguje",
    "steps": [
      {
        "title": "Overíte si telefónne číslo",
        "descBefore": "Zadáte telefónne číslo, príde vám SMS kód a v ",
        "linkText": "appke",
        "descAfter": " založíte tím. Trvá to pár minút."
      },
      {
        "title": "Pridáte zamestnancov",
        "description": "Zadáte meno a telefónne číslo — alebo nahráte zoznam z Excelu. Každému príde SMS pozvánka a prihlási sa číslom."
      },
      {
        "title": "Vytlačíte QR plagát",
        "description": "Hotový A4 plagát s QR kódom a návodom zavesíte tam, kde ľudia prichádzajú do práce."
      },
      {
        "title": "Ľudia pracujú v appke",
        "description": "Označia si príchod, vidia kolegov a firemné novinky. Vy vidíte všetko na dashboarde."
      }
    ]
  },
  "employeeApp": {
    "title": "Čo získate ako zamestnanec",
    "intro": "Stiahnete appku, prihlásite sa cez SMS a máte dochádzku, tím aj firemné správy na jednom mieste — v telefóne.",
    "highlights": [
      {
        "title": "Príchod cez QR",
        "description": "Naskenujete kód na pracovisku — bez papierov a čakania."
      },
      {
        "title": "Dochádzka v telefóne",
        "description": "História zmien a prestávok kedykoľvek poruke."
      },
      {
        "title": "Kto z kolegov pracuje",
        "description": "Vidíte, kto je v práci a kto má voľno."
      },
      {
        "title": "Firemný chat a feed",
        "description": "Novinky, ankety a skupinové chaty — oddelené od súkromných správ."
      }
    ],
    "badgesLabel": "Stiahnite si mobilnú aplikáciu",
    "heroAlt": "Effzone — status v práci a firemný feed",
    "galleryLabel": "Ukážky z mobilnej appky",
    "gallery": [
      {
        "alt": "Effzone — prehľad dochádzky v kalendári",
        "caption": "Dochádzka"
      },
      {
        "alt": "Effzone — firemný chat",
        "caption": "Chat a hovory"
      },
      {
        "alt": "Effzone — priečinky a projekty v chate",
        "caption": "Priečinky a projekty"
      }
    ]
  },
  "useCases": {
    "title": "Pre koho to dáva zmysel",
    "intro": "Tam, kde sa dnes dochádzka a komunikácia riešia cez papier, mail alebo súkromné chaty.",
    "items": [
      {
        "title": "Firmy, kde sa veľa píše na WhatsApp",
        "description": "Keď sa pracovné správy strácajú medzi osobnými konverzáciami, jedna firemná appka dáva väčší zmysel."
      },
      {
        "title": "Tímy s viacerými pracoviskami",
        "description": "QR na každom mieste a prehľad, kto kde pracuje — bez papierových výkazov na každom objekte."
      },
      {
        "title": "Častý nástup nových ľudí",
        "description": "Admin pridá číslo, človek sa prihlási a hneď vidí tím, pozície a čo sa vo firme deje."
      },
      {
        "title": "Malé a stredné firmy",
        "description": "Bez veľkého HR systému, ale s potrebou vedieť, kto je v práci a dohodnúť sa ako tím."
      }
    ]
  },
  "pricing": {
    "title": "Cenník",
    "badge": "Prvé 3 mesiace zadarmo",
    "priceUnit": "/ aktívny zamestnanec / mesiac",
    "included": [
      "Všetky funkcie v jednej cene — dochádzka, chat, hovory aj AI asistent",
      "Platíte len za aktívnych zamestnancov",
      "Neobmedzený počet pracovísk a QR kódov",
      "Bez viazanosti a bez vstupných nákladov",
      "Podklady pre mzdy na pár klikov (export do Excelu)"
    ],
    "cta": "Vyskúšať 3 mesiace zadarmo",
    "note": "Ceny sú uvedené bez DPH. Za zamestnancov bez aktivity v danom mesiaci neplatíte nič. Pri registrácii nezadávate platobnú kartu."
  },
  "download": {
    "title": "Effzone na každom vašom zariadení",
    "subtitle": "Jeden účet, rovnaké dáta. Dochádzka aj firemný chat na počítači aj v mobile.",
    "downloadFor": "Stiahnuť pre",
    "ctaAppStore": "Stiahnuť z App Storu",
    "ctaGooglePlay": "Stiahnuť z Google Play",
    "mac": "macOS",
    "windows": "Windows",
    "linux": "Linux",
    "ios": "iPhone / iPad",
    "iosDevices": "iPhone a iPad",
    "android": "Android",
    "appStore": "App Store",
    "googlePlay": "Google Play",
    "appleSilicon": "len Apple Silicon (M1 a novšie)",
    "universal": "Apple Silicon aj Intel",
    "sectionDesktop": "Počítač",
    "sectionMobile": "Mobil",
    "yourSystem": "Váš systém",
    "altDesktop": "Máte iný počítač?",
    "altMobile": "Effzone je aj na počítači —",
    "others": "Ostatné platformy",
    "loading": "Načítavam verzie…",
    "smartscreen": "Windows môže pri prvom spustení ukázať SmartScreen — balík zatiaľ nie je podpísaný. Kliknite na „Ďalšie informácie“ a potom „Spustiť aj tak“.",
    "feedError": "Verzie na stiahnutie sa nepodarilo načítať.",
    "retry": "Skúsiť znova",
    "fact": {
      "notarized": {
        "title": "Podpísané a overené Applom",
        "text": "macOS balík prešiel notarizáciou, Gatekeeper ho pustí bez obchádzok."
      },
      "selfUpdate": {
        "title": "Aktualizuje sa sama",
        "text": "Novú verziu si stiahne na pozadí, nemusíte sem chodiť znova."
      },
      "sameAccount": {
        "title": "Ten istý účet",
        "text": "Prihlásite sa rovnako ako v prehliadači, dáta sú tie isté."
      }
    }

  }
};

export default sk;
